module.exports = __webpack_public_path__ + "img/hr-sand-rock-medium-11.8df72bf6.png";